/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum EnStationComponentType {
    MOTHERBOARD = 'MOTHERBOARD',
    DISPLAY = 'DISPLAY',
    WEBCAM = 'WEBCAM',
    RFIDREADER = 'RFID_READER',
    SPEAKERS = 'SPEAKERS'
}

